<script setup lang="ts">
import { faAngleRight } from '@fortawesome/pro-light-svg-icons'

defineProps<{
  open: boolean
}>()
</script>

<template>
  <div
    class="flex items-center justify-center w-8 h-8 self-start rounded-lg hover:bg-blurple-50 dark:hover:bg-surface-hover focus:outline-none focus:ring-blurple-300 transition-colors"
    :class="{
      'bg-carbon-50': open,
    }"
  >
    <Icon
      :icon="faAngleRight"
      class="transition-transform duration-300"
      :class="{ 'rotate-90': open }"
    />
  </div>
</template>
